import React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from "./style/index.scss"

export default class XiaoTianStartApp extends ComponentExt<any, any> {
    state: { iccid: string; imei: string; msg: string; }
    constructor(props) {
        super(props)
        this.state = {
            iccid: '',
            imei: '',
            msg: ''
        }
    }

    async componentDidMount() {
        document.title = '启动程序'

        if ((window as any).jsbridge) {
            try {
                //coreappsRequest32 调用32位程序的插件
                var sn = await (window as any).jsbridge.coreappsRequest('NEWPLUGIN_WIN32MBNPLUGIN_HELLO', '')
                if (sn && sn != ',') {
                    (window as any).jsbridge.startSmallApp({
                        appid: "202411191820335276",
                        url: "https://aoac.lenovoconnect.com/index.html#/mobileXiaoTian",
                        title: "懂的智联",
                        width: "1440",
                        height: "900",
                        minwidth: "1152",
                        minheight: "720",
                        data: `{"iccid":"${sn.split(',')[0]}","imei":"${sn.split(',')[1]}"}`
                    })
                    this.setState({
                        iccid: sn.split(',')[0],
                        imei: sn.split(',')[1],
                        msg: '好的，已为您开启。'
                    })
                } else {
                    this.setState({
                        msg: '抱歉，开启程序失败。',
                    })
                }
            } catch (error) {
                this.setState({
                    msg: '抱歉，开启程序失败。',
                })
            }
        } else {
            this.setState({
                msg: '抱歉，开启程序失败。',
            })
        }

    }
    render() {
        return (
            <>
                <div className={styles.Xiaotian} style={{ background: 'unset' }}>
                    <div className={styles.contentBuble}>{this.state.msg}</div>
                </div>
            </>
        )
    }
}
